var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user 1",
    clipPath: "url(#clip0_10966_31144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.88599 7.70728C8.94482 7.70728 9.86169 7.32751 10.6108 6.57825C11.36 5.8291 11.7397 4.91248 11.7397 3.85352C11.7397 2.79492 11.36 1.87817 10.6107 1.12878C9.86145 0.379761 8.9447 0 7.88599 0C6.82703 0 5.9104 0.379761 5.16125 1.12891C4.41211 1.87805 4.03223 2.7948 4.03223 3.85352C4.03223 4.91248 4.41211 5.82922 5.16138 6.57837C5.91064 7.32739 6.82739 7.70728 7.88599 7.70728Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.629 12.3011C14.6074 11.9894 14.5637 11.6493 14.4994 11.2902C14.4344 10.9283 14.3508 10.5863 14.2507 10.2737C14.1473 9.95056 14.0067 9.63147 13.8329 9.32568C13.6525 9.0083 13.4406 8.73193 13.2028 8.50452C12.9541 8.2666 12.6497 8.07532 12.2976 7.93579C11.9468 7.797 11.558 7.72668 11.1421 7.72668C10.9788 7.72668 10.8208 7.7937 10.5157 7.99231C10.328 8.11475 10.1084 8.25635 9.86328 8.41296C9.65369 8.54651 9.36975 8.67163 9.01904 8.78491C8.67688 8.89563 8.32947 8.95178 7.98657 8.95178C7.64368 8.95178 7.29639 8.89563 6.95386 8.78491C6.60352 8.67175 6.31958 8.54663 6.11023 8.41309C5.86743 8.25793 5.64771 8.11633 5.45715 7.99219C5.15247 7.79358 4.99438 7.72656 4.83105 7.72656C4.41504 7.72656 4.02637 7.797 3.67566 7.93591C3.32385 8.0752 3.01929 8.26648 2.77039 8.50464C2.53271 8.73218 2.32068 9.00842 2.1405 9.32568C1.9668 9.63147 1.82617 9.95044 1.72266 10.2738C1.62268 10.5864 1.53906 10.9283 1.47412 11.2902C1.40979 11.6488 1.36609 11.989 1.34448 12.3015C1.32324 12.6077 1.3125 12.9254 1.3125 13.2463C1.3125 14.0815 1.578 14.7577 2.10156 15.2563C2.61865 15.7484 3.30286 15.998 4.13489 15.998H11.839C12.671 15.998 13.355 15.7485 13.8722 15.2563C14.3959 14.7581 14.6614 14.0818 14.6614 13.2462C14.6613 12.9238 14.6504 12.6058 14.629 12.3011Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10966_31144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.0001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user_avatar.0d939d6b16befa6c2853ae62de5b1cda.svg";
export { ForwardRef as ReactComponent };